import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useRequisicaoServicosProdutosListaPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useRequisicaoServicosProdutosListaPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));